const REGISTRATION_RESUME_INTENT_KEY = "registration_resume_intent";
const REGISTRATION_PROGRESS_PREFIX = "registration_progress";

const getUserId = (user: any): string | null => {
  if (!user) return null;
  return user.id || user._id || user.userId || user.email || null;
};

const getAccountType = (user: any): string => {
  return String(user?.accountType || "Homeowner");
};

const getProgressKey = (user: any): string | null => {
  const userId = getUserId(user);
  if (!userId) return null;
  return `${REGISTRATION_PROGRESS_PREFIX}:${getAccountType(user)}:${userId}`;
};

const isValidStep = (step: number): boolean => Number.isInteger(step) && step >= 0 && step <= 5;

export const setRegistrationResumeIntent = () => {
  try {
    sessionStorage.setItem(REGISTRATION_RESUME_INTENT_KEY, "1");
  } catch (error) {
    // no-op
  }
};

export const hasRegistrationResumeIntent = () => {
  try {
    return sessionStorage.getItem(REGISTRATION_RESUME_INTENT_KEY) === "1";
  } catch (error) {
    return false;
  }
};

export const clearRegistrationResumeIntent = () => {
  try {
    sessionStorage.removeItem(REGISTRATION_RESUME_INTENT_KEY);
  } catch (error) {
    // no-op
  }
};

export const getRegistrationProgressStep = (user: any): number | null => {
  const key = getProgressKey(user);
  if (!key) return null;

  try {
    const rawValue = localStorage.getItem(key);
    if (!rawValue) return null;
    const parsed = parseInt(rawValue, 10);
    return isValidStep(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
};

export const setRegistrationProgressStep = (user: any, step: number) => {
  if (!isValidStep(step)) return;
  const key = getProgressKey(user);
  if (!key) return;

  try {
    localStorage.setItem(key, String(step));
  } catch (error) {
    // no-op
  }
};

export const clearRegistrationProgressStep = (user: any) => {
  const key = getProgressKey(user);
  if (!key) return;

  try {
    localStorage.removeItem(key);
  } catch (error) {
    // no-op
  }
};
